import { useEffect } from 'react'
import '../css/pages/settings.css'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux' 
import { getMyData } from '../features/profile/profileSlice'
import SettingsComponent from '../components/settings/SettingsComponent'
import UpdateComponent from '../components/settings/UpdateComponent' 
import styled from 'styled-components' 
import Loader from "loaders/Loader"; 
import { toast } from 'react-toastify'
import { setConfirmModalData, setViewConfirmModal } from 'features/modal/modalSlice'
import { PageContainerMain } from './pages.styled'
import Modal from '@mui/material/Modal';
import { addAc, setViewLanguageModal } from 'features/auth/authSlice'
import { addAcFunc } from 'funcs/ac'
import LanguageModal from 'components/settings/LanguageModal'
import Sidebar from 'components/Sidebar'


function Settings() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user, isError, message, viewLanguageModal } = useSelector((state) => state.auth)
  const { isSuccess, isLoading} = useSelector((state) => state.profile)  
  const { isMemberActionSuccess, isMemberActionError, memberActionMessage } = useSelector((state) => state.memberships2)

  useEffect(() => { 
    if (isMemberActionSuccess) {
      toast(memberActionMessage)
      dispatch(setConfirmModalData({
          text: '',
          handler: null,
          confirmBtnBackgroundHover: null,
          extraInfo: null
      }))
      dispatch(setViewConfirmModal(false))
    }else if(isMemberActionError){
      toast(memberActionMessage)
      dispatch(setConfirmModalData({
        text: '',
        handler: null,
        confirmBtnBackgroundHover: null,
        extraInfo: null
    }))
    dispatch(setViewConfirmModal(false))
    }
  }, [isMemberActionSuccess, dispatch, isMemberActionError, memberActionMessage])

  useEffect(() => {
    if (isError) { console.log(message)}
    if (!user) { navigate('/login') }
    dispatch(getMyData())
    // return () => { dispatch(resetProfile()) } //changed  
  }, [user, dispatch, navigate, isError, message])

  useEffect(() => {

    const dis = () => dispatch(addAc({
      type: 'settings', 
    }))

    addAcFunc('settings', dis)

  }, [])


  return (
      <PageContainerMain> 

            <Sidebar /> 
            <SettingsComponent  />
            <SettingToUpdateWrap>
                { isSuccess?
                  ( <UpdateComponent  /> )
                  : isLoading ?
                  ( 
                    <div style={{marginTop: '50px'}}> 
                      <Loader /> 
                    </div> 
                  )
                  :
                  ( null )
                  }
            </SettingToUpdateWrap>
 


          <Modal
            open={viewLanguageModal}
            style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClose={() => dispatch(setViewLanguageModal(false))}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div
              style={{
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center',  
                width: '100vw', 
                height: '100vh',  
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
              }}
              >   
                <LanguageModal />
            </div>
          </Modal>

        </PageContainerMain> 
  )
}
export default Settings


const SettingToUpdateWrap = styled.div`

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    width: min(680px, 100%);
    height: 100%;

    @media (max-width: 768px) {
      width: 100%;
      min-width: 0;
    }
`
